export enum FindMyCarStatusTypes {
  UNSET = "UNSET",
  SETTING_POSITION = "SETTING_POSITION",
  SAVED = "SAVED",
}

export interface SliceProps {
  status: FindMyCarStatusTypes;
  coordinates: null | { lat: number; lng: number };
  floorId: number | null;
}
